<script setup lang="ts">
import MamanomikataBanner from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/organisms/_lp/PartnerPontaBannerList/banner_mamanomikata.png/banner_mamanomikata.webp';
import OkanenomikataBanner from '/home/runner/_work/shadow/shadow/packages/app/node_modules/.cache/home/runner/_work/shadow/shadow/packages/app/src/components/organisms/_lp/PartnerPontaBannerList/banner_okanenomikata.png/banner_okanenomikata.webp';
import IconStar from 'theme/components/atoms/icons/IconStar.vue';

const bannerLinks = computed(() => {
  return [
    {
      src: OkanenomikataBanner,
      alt: '【Ponta】お金のミカタ｜あなたの味方“Ponta[ポンタ]“の金融総合サイト',
      href: 'https://www.finance.ponta.jp/?utm_source=okane-kenko.jp&utm_medium=banner&utm_campaign=okane-kenko_real-time_result-page',
    },
    {
      src: MamanomikataBanner,
      alt: '【Ponta】お金のミカタ｜がんばるママのミカタ特集',
      href: 'https://www.finance.ponta.jp/lp/foryou/mama/?utm_source=okane-kenko&utm_medium=banner&utm_campaign=okane-kenko_real-time_result-page_timez_240925',
    },
  ];
});
</script>

<template>
  <section :class="$style.section">
    <header :class="$style.header">
      <IconStar :class="$style.header__icon" />
      <h2 :class="$style.header__title">おすすめサービス</h2>
    </header>
    <ul :class="[$style.section__contents, $style.banners]">
      <li
        v-for="(link, index) in bannerLinks"
        :key="index"
        :class="$style.banners__item"
      >
        <a
          :href="link.href"
          target="_blank"
          rel="noopener"
          :class="$style.banner"
        >
          <img :src="link.src" :alt="link.alt" />
        </a>
      </li>
    </ul>
  </section>
</template>

<style lang="scss" module>
.section {
  display: flex;
  align-items: center;
  flex-direction: column;
  width: 100%;

  &__contents {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}

.header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2px;

  &__icon {
    font-size: 32px;
    color: $color-text-and-object-accent-primary;
  }

  &__title {
    font-size: 20px;
    color: $color-text-and-object-high-emphasis;
  }
}

.banners {
  $banner-width: 343px;
  $gap: 20px;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, max-content));
  align-items: center;
  justify-content: center;
  gap: $gap;
  width: 100%;
  max-width: ($banner-width * 2) + $gap;
}

.banner {
  display: block;

  @include is-pointer-device {
    transition: opacity $transition-interaction;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
